import { render } from "./ModalDocs.vue?vue&type=template&id=c32f139c"
import script from "./ModalDocs.vue?vue&type=script&lang=js"
export * from "./ModalDocs.vue?vue&type=script&lang=js"

import "./ModalDocs.vue?vue&type=style&index=0&id=c32f139c&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__